import PromotionCouponModel from './promotion_coupon.model'

let storeContent = utils.generateStore({
   PromotionCouponModel,
   promotion_coupons: [],
   resetForm: false,
   selected_promotion_coupons: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addPromotionCoupon(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.data

            let res = await api.fetchEndpoint({
               resource: 'commons',
               action: 'insert',
               data: {
                  record: {
                     code: data.code,
                     name: data.name,
                     description: data.description,
                     discount_val: data.discount_type.form_data.discount_val,
                     discount_type: data.discount_type.selected_option,
                     product_name: data.discount_type.form_data.product_name,
                     max_discount_amount: data.discount_type?.form_data?.max_discount_amount,
                     min_amount_spent: data.min_amount_spent,
                     max_amount_spent: data.max_amount_spent,
                     max_coupons_amount: data.max_coupons_amount,
                     from: dayjs(`${data.from} 00:00:00`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                     to: dayjs(`${data.to} 23:59:59`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                     multiple_coupons_config: data.multiple_coupons_config,
                     products: data.products,
                     stations: data.stations,
                     countries: data.countries,
                     regions: data.regions,
                     channels: data.channels,
                     remption_stations: data.remption_stations,
                     transaction_types: data.transaction_types,
                     transaction_subtypes: data.transaction_subtypes,
                     currencies: data.currencies,
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "promotion_coupon",
               }
            })

            ctx.commit('resetForm', true)
            await ctx.dispatch('fetchPromotionCoupon')
            ctx.commit('show_create_modal', false)
            $notify('success', 'Promotion Coupon Created', `Promotion Coupon ${data.name} successfully created.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updatePromotionCoupon(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.data

            let res = await api.fetchEndpoint({
               resource: 'commons',
               action: 'update',
               data: {
                  id: ctx.getters.selected_promotion_coupons[0]._id,
                  record: {
                     code: data.code,
                     name: data.name,
                     description: data.description,
                     discount_val: data.discount_type.form_data.discount_val,
                     discount_type: data.discount_type.selected_option,
                     product_name: data.discount_type.form_data.product_name,
                     max_discount_amount: data.discount_type?.form_data?.max_discount_amount,
                     min_amount_spent: data.min_amount_spent,
                     max_amount_spent: data.max_amount_spent,
                     max_coupons_amount: data.max_coupons_amount,
                     from: dayjs(`${data.from} 00:00:00`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                     to: dayjs(`${data.to} 23:59:59`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                     multiple_coupons_config: data.multiple_coupons_config,
                     products: data.products,
                     stations: data.stations,
                     countries: data.countries,
                     regions: data.regions,
                     channels: data.channels,
                     remption_stations: data.remption_stations,
                     transaction_types: data.transaction_types,
                     transaction_subtypes: data.transaction_subtypes,
                     currencies: data.currencies,
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "promotion_coupon",
               }
            })

            ctx.commit('resetForm', true)
            await ctx.dispatch('fetchPromotionCoupon')
            ctx.commit('show_edit_modal', false)
            $notify('success', 'Promotion Coupon Updated', `Promotion Coupon ${data.name} successfully updated.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deletePromotionCoupon(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const promotion_coupon of ctx.getters.selected_promotion_coupons) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: promotion_coupon._id,
                  },
                  meta_data: {
                     service: "rewards",
                     collection: "promotion_coupon",
                  }
               })
            }

            await ctx.dispatch('fetchPromotionCoupon')
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Promotion Coupon Deleted', `<b>${ctx.getters.selected_promotion_coupons.length}</b> Promotion Coupon successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'promotion_coupon:edit') {
            let PromotionCouponModel = ctx.getters.PromotionCouponModel
            // set the discount type
            payload.rows[0].discount_type = {
               selected_option: payload.rows[0].discount_type,
               form_data: {
                  discount_val: payload.rows[0].discount_val,
                  max_discount_amount: payload.rows[0].max_discount_amount || 0,
                  product_name: payload.rows[0].product_name,
               },
            }
            
            PromotionCouponModel.forms.mainDetailsEdit.data = payload.rows[0]
            PromotionCouponModel.forms.lockRulesEdit.data = payload.rows[0]
            PromotionCouponModel.forms.otherConfigsEdit.data = payload.rows[0]

            PromotionCouponModel.forms.mainDetailsEdit.data.from = dayjs(PromotionCouponModel.forms.mainDetailsEdit.data.from).format('DD-MM-YYYY')
            PromotionCouponModel.forms.mainDetailsEdit.data.to = dayjs(PromotionCouponModel.forms.mainDetailsEdit.data.to).format('DD-MM-YYYY')
            
            ctx.commit('selected_reward_rules', payload.rows)
            console.log(ctx.getters.selected_reward_rules)
            ctx.commit('PromotionCouponModel', PromotionCouponModel)
            ctx.commit('show_edit_modal', true)
         } else if (payload.action === 'promotion_coupon:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Promotion Coupon`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_promotion_coupons', payload.rows)
         } else if (payload.action === 'view:redemptions') {
            ctx.getters.router.push({name: 'PromotionCoupon-View_Redemptions', params: {id: payload.rows[0]._id}})
         }
      },
      async fetchPromotionCoupon(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "promotion_coupon",
               }
            })
            ctx.commit('promotion_coupons', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            let res = null, Model = ctx.getters.PromotionCouponModel

            // Fetch Transaction Channels
            res = await api.fetchEndpointSecureRefresh({ resource: 'configs',action: 'list:countries', data: { }, meta_data: {}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'countries', label: '_id', dataField: '_id', data: res.result.regions})

            // Fetch Transaction Channels
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { }, meta_data: {service: "rewards",collection: "currency"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'currencies', label: 'name', dataField: 'code', data: res.result.records})

            // Fetch Transaction Channels
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { }, meta_data: {service: "rewards",collection: "channel"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'channels', label: 'name', dataField: 'code', data: res.result.records})

            // Fetch Transaction Types
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { }, meta_data: {service: "rewards",collection: "transaction_type"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'transaction_types', label: 'name', dataField: 'code', data: res.result.records})

            // Fetch Transaction Channels
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { }, meta_data: {service: "rewards",collection: "transaction_sub_type"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'transaction_subtypes', label: 'name', dataField: 'code', data: res.result.records})

            // Fetch Redemption Stations
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { }, meta_data: {service: "rewards",collection: "station"}})
            Model = utils.appendSelectData({ Model, forms: ['otherConfigs','otherConfigsEdit'], model: 'remption_stations', label: 'name', dataField: 'code', data: res.result.records})
            
            // Fetch Products
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { }, meta_data: {service: "rewards",collection: "product"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'products', label: 'name', dataField: 'code', data: res.result.records})


            ctx.commit('PromotionCouponModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchRegions(ctx,payload){
         try {
            let res = null, Model = ctx.getters.PromotionCouponModel
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { rules: { match: { country: {$in: payload.data} } } }, meta_data: {service: "rewards",collection: "region"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'regions', label: 'county', dataField: 'county', data: res.result.records})
            ctx.commit('PromotionCouponModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchStations(ctx,payload){
         try {
            let res = null, Model = ctx.getters.PromotionCouponModel
            res = await api.fetchEndpointSecureRefresh({ resource: 'commons',action: 'list', data: { rules: { match: { region: {$in: payload.data} } } }, meta_data: {service: "rewards",collection: "station"}})
            Model = utils.appendSelectData({ Model, forms: ['lockRules','lockRulesEdit'], model: 'stations', label: 'name', dataField: 'code', data: res.result.records})
            ctx.commit('PromotionCouponModel', Model)
         } catch (err) {
            throw err
         }
      },
      async selectFieldChanged(ctx,payload){
         try {
            ctx.commit('loading',true)
            
            if(payload.form.model === 'countries' && payload.data && payload.data.length > 0){
               await ctx.dispatch('fetchRegions',payload)
            }else if(payload.form.model === 'regions' && payload.data && payload.data.length > 0){
               await ctx.dispatch('fetchStations',payload)
            }
            ctx.commit('loading',false)
         } catch (err) {
            ctx.commit('loading',false)
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchPromotionCoupon')
            await ctx.dispatch('fetchFormData')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};